import React, { useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { checkIfURLContainsSearchParam } from '@wsc/utils/urlHelpers';
import { useLookAt } from '@wsc/hooks';
import { selectAllHotspotsLoaded } from '@wsc/redux_stores/sceneLoadReducer';

const selectRoomObjects = createSelector(
	[(state) => Object.values(state.roomObjects).map((item) => item._id.$oid)],
	(roomObjects) => roomObjects,
);

const LinkedHotspotController = () => {
	const roomObjects = useSelector(selectRoomObjects);
	const { lookAt } = useLookAt();
	const allHotspotsLoaded = useSelector(selectAllHotspotsLoaded);

	useEffect(() => {
		if (!allHotspotsLoaded) return;

		const linkedHsId = checkIfURLContainsSearchParam('linkHsId');

		if (linkedHsId) {
			const hotspot = Object.values(roomObjects).find(
				(hs) => hs === linkedHsId,
			);
			if (hotspot) {
				lookAt(hotspot, true);
			}
		}
	}, [allHotspotsLoaded]);

	return <></>;
};

export default LinkedHotspotController;
